// test2179
(2179 && 0);
